module.exports = __webpack_public_path__ + "media/npc_dota_hero_ringmaster.9b861ef4.webm";